import { __assign } from "tslib";
import * as React from 'react';
import { forwardRef, memo } from 'react';
var MoreHoriz = memo(forwardRef(function (props, ref) { return (React.createElement("svg", __assign({ viewBox: "0 0 32 32", xmlns: "http://www.w3.org/2000/svg", ref: ref }, props),
    React.createElement("path", { d: "M9 16a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0zm9.5 0a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0zm9.5 0a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0z" }))); }));
MoreHoriz.displayName = 'MoreHoriz';
MoreHoriz['iconName'] = 'more_horiz';
export default MoreHoriz;
